import { useGetDefaultPage } from '@/api/websiteApi';
import { ContactForm } from '@/page-sections/contact/contact-form';
import { ContactMap } from '@/page-sections/contact/contact-map';
import { HeroContact } from '@/page-sections/HeroContact';
import { HeroContactSection } from '@/types/sections/HeroContactSection';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useEffect } from 'react';
import { Location } from '@/types/sections/HeroContactSection';

type PropTypes = {
  uri: string;
};

export default function ContactPage({ uri }: PropTypes) {
  const { data, loading } = useGetDefaultPage(uri);
  const sectionsHero = data?.sections?.find(
    (section) => section.fieldGroupName === 'SectionsComponentsHeroContactLayout'
  ) as HeroContactSection;

  const mapLocationsToContacts = (locations: Location[]) => {
    return locations.map((location) => ({
      latlng: [parseFloat(location.geo.lat), parseFloat(location.geo.lon)],
      address: location.address,
      phoneNumber: location.phone,
    }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return null;
  }

  return (
    <>
      {sectionsHero && <HeroContact section={sectionsHero} />}
      <Container component="section" sx={{ py: 10 }}>
        <Box
          sx={{
            gap: 10,
            display: 'grid',
            gridTemplateColumns: { xs: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' },
          }}>
          <ContactForm />

          <ContactMap contacts={mapLocationsToContacts(sectionsHero.locations || [])} />
        </Box>
      </Container>
    </>
  );
}
